import { JSX } from 'react';
import { Placeholder, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { TESTIMONIAL_CARDS } from 'src/shared/static';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';
import { Button, Text, RichText } from '@ahc-digital/component-library';
import { translationClasses } from 'src/shared/TranslationClasses';
import { C44TestimonialsProps } from './C44Testimonials.types';
import { GetTestimonialsModel } from './C44Testimonials.service';
import { Testimonials } from '@ahc-digital/component-library';
import { ColumnGrid, Container } from '@ahc-digital/component-library';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C44TestimonialsProps): JSX.Element => {
  const phKey = TESTIMONIAL_CARDS + `-${props?.params?.DynamicPlaceholderId}`;
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing ?? false;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const model = GetTestimonialsModel(props);

  if (isEditing) {
    return (
      <SwitchToPreviewMessage componentName={props?.rendering?.componentName}>
        <Container>
          <div style={{ display: 'grid', gap: '1.5rem' }}>
            <Text>{model?.headline}</Text>
            <RichText>{model?.supportCopy}</RichText>
            <ColumnGrid
              columns={'1'}
              columnsTablet={Number(model?.numberOfColumns) > 2 ? '2' : model?.numberOfColumns}
              columnsDesktop={model?.numberOfColumns}
            >
              {props?.rendering && <Placeholder name={phKey} rendering={props?.rendering} />}
            </ColumnGrid>
            <Button>{model?.expandButtonText}</Button>
          </div>
        </Container>
      </SwitchToPreviewMessage>
    );
  }

  return (
    <Testimonials
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};

export default checkDatasourceForRendering<C44TestimonialsProps>(Default);
